// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/papers.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/papers.proto.
 */
export const file_proto_model_core_papers = /*@__PURE__*/
  fileDesc("Ch1wcm90by9tb2RlbC9jb3JlL3BhcGVycy5wcm90bxIGY2FybWVuImIKBlBhcGVycxIfCgR0eXBlGAEgASgOMhEuY2FybWVuLlBhcGVyVHlwZRIOCgZpc3N1ZXIYAiABKAkSDgoGbnVtYmVyGAMgASgJEhcKD2V4cGlyYXRpb25fZGF0ZRgEIAEoCSqZAQoJUGFwZXJUeXBlEhoKFlBBUEVSX1RZUEVfVU5TUEVDSUZJRUQQABIXChNQQVBFUl9UWVBFX1BBU1NQT1JUEAESEwoPUEFQRVJfVFlQRV9WSVNBEAISHgoaUEFQRVJfVFlQRV9EUklWSU5HX0xJQ0VOU0UQAxIiCh5QQVBFUl9UWVBFX1BFUk1BTkVOVF9SRVNJREVOQ0UQBEIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the message carmen.Papers.
 * Use `create(PapersSchema)` to create a new message.
 */
export const PapersSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_papers, 0);

/**
 * Describes the enum carmen.PaperType.
 */
export const PaperTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_papers, 0);

/**
 * @generated from enum carmen.PaperType
 */
export const PaperType = /*@__PURE__*/
  tsEnum(PaperTypeSchema);

